import { Template } from './Template'

export const mapTemplateToCreatorTwitterId: Record<Template, string> = {
  apex1: 'riocurara',
  apex2: 'nopota__',
  apex3: 'koharubiyori_51',
  apex4: 'o2_o2222',
  apex5: 'shiina_icg',
  apex6: 'bun02gaw02',
  apex7: 'goma_pons',
  apex8: '__nanasi_chan',
  apex9: '_may_0615',
  apex10: 'coffee_mameee',
  apex11: 'akarin3331',
  apex12: 'NICOLE_limacina',
  apex13: '_SHIROMISAKANA_',
  apex14: 'mocchi00561',
  apex15: 'sqtmr',
  apex16: 'c_asaaai',
  apex17: 'aaa__x_x__',
  apex18: 'yokoi_0w0',
  apex19: 'ibless0316',
  apex20: 'noonereno',
  apex21: 'pyon9956',
  apexMobile1: 'N529526',
  apexMobile2: 'riocurara',
  valorant1: 'koharubiyori_51',
  valorant2: 'natsuko_game',
  valorant3: 'Nonax299',
  valorant4: 'bokuwanco',
  valorant5: 'nawowcow',
  valorant6: 'tsunaegg',
  valorant7: 'shirobe_xx',
  valorant8: 'cott0n_x',
  valorant9: 'purimipurioka',
  valorant10: 'RiU__Sky',
  fortnite1: 'S3_0907',
  fortnite2: 'koharubiyori_51',
  genshin1: 'genshinlev',
  genshin2: 'koharubiyori_51',
  dbd1: 'aisan000531',
  dbd2: 'watashiwatotem',
  dbd3: 'paultask_game',
  amongus1: '_pira__',
  amongus2: 'o0560o',
  amongus3: '__nyan299',
  monsterhunterrise1: 'koharubiyori_51',
  monsterHunterRiseSunBreak1: 'MHR_Qoo',
  monsterHunterRiseSunBreak2: 'nano_10moya3',
  monsterHunterRiseSunBreak3: 'jonpi1219',
  monsterHunterWilds1: 'MHR_Qoo',
  pokemonUnite1: 'MHR_Qoo',
  splatoon3_1: 'koharubiyori_51',
  splatoon3_2: 'sakiika10_game',
  splatoon3_3: 'MHR_Qoo',
  splatoon3_4: 'ibless0316',
  splatoon3_5: 'MHR_Qoo',
  splatoon3_6: '_pira__',
  splatoon3_7: 'MHR_Qoo',
  fallguys1: 'sakiika10_game',
  overwatch2_1: 'Russet_Down',
  overwatch2_2: 'osarusyaaan',
  overwatch2_3: 'riocurara',
  overwatch2_4: 'monamona_game',
  codMw2_1: 'jmlll15',
  codMw2_2: 'jmlll15',
  codMw3_1: 'jmlll15',
  codBo6_1: 'jmlll15',
  gundamEvolution1: 'koharubiyori_51',
  blueProtocol1: 'igucheese',
  blueProtocol2: 'igucheese',
  myHeroAcademiaUltraRumble1: 'KANESHIRONOYUKI',
  myHeroAcademiaUltraRumble2: 'riocurara',
  bf2042_1: 'uni_3221',
  pazudora1: 'MHR_Qoo',
  marvelRivals1: 'ryunokomachi',
  simpleTemplate: '',
}
